import React from "react";
import { brand } from "../../../../config/brand";

export const getBrand = () => brand;

export const getBrandVariant = (variant = "desktop") =>
  brand.variants?.[variant] ?? brand.variants.desktop;

export const renderBrandTitle = () =>
  brand.lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < brand.lines.length - 1 && <br />}
    </React.Fragment>
  ));

  export const brandService = {
    getBrand,
    getBrandVariant,
};